import * as _ from "lodash";
import * as angular from "angular";
import { Filter } from "../models/filter.model";
import { AppointmentFilter } from "../models/appointment-filter.model";

export class CheckManager {
    public all_checked: boolean = false;
    public checked_items = [];
    public unchecked_items = [];
    public items = [];
    public checked_items_count = 0;
    public matched_count = 0;
    public loading = false;
    public hideNavOnCheckAll = true;

    constructor(items?: any[]) {
        this.setData(items);
    }

    setData(items?: any[]): void {
        if (items) this.items = items;
    }

    setTotalCount(count: number): void {
        this.matched_count = count;
    }

    setLoading(loading: boolean): void {
        this.loading = loading;
    }

    checkAll(bool: boolean): void {
        if (angular.isDefined(bool)) {
            //Called programmatically as opposed to relying on the model
            this.all_checked = bool;
        }
        this.checked_items = [];
        this.unchecked_items = [];

        for (let i = 0; i < this.items.length; i++) {
            this.check(this.all_checked, this.items[i]);
        }
    }

    checkNewItem(item: any): void {
        if (this.all_checked) {
            item.checked = true;
        }
    }

    check(checkBool: boolean, item: any): void {
        item.checked = checkBool;
        const checkedItemID = item.getID();
        if (checkBool) {
            this.checked_items.push(checkedItemID);
            this.spliceFromArray(checkedItemID, this.unchecked_items);
        } else {
            this.unchecked_items.push(checkedItemID);
            this.spliceFromArray(checkedItemID, this.checked_items);
        }
        this.updateCheckedCounts();
    }

    spliceFromArray(checkItem: any, array: Array<any>): void {
        for (let i = 0; i < array.length; i++) {
            if (array[i] == checkItem) {
                array.splice(i, 1);
            }
        }
    }

    removeCheckedItems(removeFromList: boolean = true): void {
        this.checked_items = [];
        this.unchecked_items = [];
        this.all_checked = false;
        for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].checked) {
                if (removeFromList) {
                    this.items.splice(i, 1);
                } else {
                    this.items[i].checked = false;
                }
                i--;
            }
        }
        this.updateCheckedCounts();
    }

    anyChecked(): boolean {
        return this.checked_items.length > 0;
    }

    bulkActionData(filters: Filter | AppointmentFilter): object {
        return {
            all_checked: this.all_checked,
            checked_items: this.checked_items,
            unchecked_items: this.unchecked_items,
            checked_items_count: this.checked_items_count,
            matched_count: this.matched_count,
            filters: _.cloneDeep(filters.nonEmptyValues()),
        };
    }

    updateCheckedCounts(): void {
        if (this.all_checked) {
            this.checked_items_count =
                this.matched_count - this.unchecked_items.length;
        } else {
            this.checked_items_count = this.checked_items.length;
        }
    }
}

angular.module("checkManager", []).service("CheckManager", CheckManager);
